import { render, staticRenderFns } from "./FormInfoBox.vue?vue&type=template&id=0d8a0563&scoped=true&"
import script from "./FormInfoBox.vue?vue&type=script&lang=js&"
export * from "./FormInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./FormInfoBox.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FormInfoBox.vue?vue&type=style&index=1&id=0d8a0563&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a0563",
  null
  
)

export default component.exports